import {BusinessCaseType} from '@dms/api/sales';
import i18n from '@dms/i18n';

export type KanbanSegment = {
  label: string;
  value: BusinessCaseType;
};

export const KANBAN_SEGMENTS: KanbanSegment[] = [
  {
    label: i18n.t('page.opportunitiesKanban.selling'),
    value: 'SELLING',
  },
  {
    label: i18n.t('page.opportunitiesKanban.buying'),
    value: 'BUYING',
  },
];
